import React from "react";
import { FeatureLayer } from "@evergis/react";

import { MapControlContainer } from "../../styled";
import { GeoLocationButton } from "./GeoLocationButton";
import { useGeoLocation } from "../../hooks/useGeoLocation";
import { usePresentationMode } from "../../../../hooks/layout/usePresentationMode";

export const GeoLocation = () => {
  const { geoLocationFeature } = useGeoLocation();
  const { isPresentationMode } = usePresentationMode();

  if (isPresentationMode) return null;

  return (
    <>
      <FeatureLayer features={geoLocationFeature} zIndex={44} />
      <MapControlContainer width="2.25rem" withPadding>
        <GeoLocationButton />
      </MapControlContainer>
    </>
  );
};
